import axiosIns from '@/api/axios'
import axiosInsAcademy from '@/api/axios-ugems-academy'

export const GET_POSITION_COMPETENCY_MAPPINGS = (params) => {
    return axiosInsAcademy.get('/position-competency-mappings', { params })
}

export const CREATE_POSITION_COMPETENCY_MAPPING = (data) => {
    return axiosInsAcademy.post('/position-competency-mappings', data)
}

export const UPDATE_POSITION_COMPETENCY_MAPPING = (id, data) => {
    return axiosInsAcademy.put(`/position-competency-mappings/${id}`, data)
}

export const GET_POSITION_COMPETENCY_MAPPING_BY_ID = (id) => {
    return axiosInsAcademy.get(`/position-competency-mappings/${id}`)
}

export const DELETE_POSITION_COMPETENCY_MAPPING = (id) => {
    return axiosInsAcademy.delete(`/position-competency-mappings/${id}`)
}

export const DOWNLOAD_POSITION_COMPETENCY_MAPPING_TEMPLATE = () => {
    return axiosInsAcademy.get('/training-mapping/bulk-download-template', {
        responseType: 'blob'
    })
}

export const UPLOAD_POSITION_COMPETENCY_MAPPING_FILE = (formData) => {
    return axiosInsAcademy.post('/training-mapping/bulk-create', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
